import {
  ContentLayout,
  PageNotFound,
  Loader,
  HeaderBreadcrumbs,
  useDropdownApis,
} from "../../../shared";
import * as React from "react";
import {
  Button,
  Stack,
  Card,
  Switch,
  Typography,
  Grid,
  Avatar,
  Box,
  TextField,
  Divider,
  Radio,
  Tooltip,
  InputAdornment,
  createFilterOptions,
  FormHelperText,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import SimpleReactValidator from "simple-react-validator";
import Avadar_img from "../../../assets/images/Icons/Avadar_img.png";
import InputControl from "../../../shared/components/InputControl";
import infoIcon from "../../../assets/images/Icons/ic_info.svg";

import "react-quill/dist/quill.snow.css";
import { useParams } from "react-router-dom";
import { useProducts } from "../hooks";

export const CreateOrEditProducts = () => {
  const { id } = useParams();
  const updateMode = id ? true : false;
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        IconFormat: {
          message: "The Image  should be png, jpg, jpeg",
          rule: (value) => {
            if (
              ![
                "image/png",
                "image/jpeg",
                "image/jpg",
                "image/svg",
                "image/gif",
              ].includes(value.type)
            ) {
              return false;
            }
          },
        },
        IconSize: {
          message: "The Image Size should be less than 1MB",
          rule: (value) => {
            const maxSize = 1048576; //1mb
            if (value?.size > maxSize) {
              return false;
            }
          },
        },
      },
    })
  );
  const colorOptions = [
    {
      value: "#A04D3D",
      label: "#A04D3D",
    },
    {
      value: "#5E7360",
      label: "#5E7360",
    },
    {
      value: "#564845",
      label: "#564845",
    },
    {
      value: "#F2F2F2",
      label: "#F2F2F2",
    },
  ];
  const {
    state,
    isCreate,
    isEditMode,
    globalData,
    categoriesList,
    taxGroupList,
    accountsList,
    onUpdateProduct,
    onSaveProduct,
    handleProductInputChange,
    handleVarientNestedInput,
    handleColor,
    handleLoyaltyCheckboxChanges,
    isLoyaltyOptionInclude,
  } = useProducts({ IsAdd: true, isDetailsId: id ? id : false });
  const {
    reportSettingsList,
  } = useDropdownApis({ isReportSettingsList: true });

  const { classes } = reportSettingsList

  const { isSaveButton, updateData, isLoading, imageData } =
    state.updateDetails;
  const {
    name,
    short_description,
    modifier,
    product_type,
    plu,
    category_id,
    image,
    tax_group_id,
    tags,
    marketing_tags,
    variants,
    has_variant,
    sticker_printing,
    old_plu,
    bump_screen_tags,
    colour,
    alias,
    kilojoules,
    redcat_category,
    redcat_plu_class,
  } = updateData;
  const onSubmit = () => {
    if (validator.current.allValid()) {
      updateMode ? onUpdateProduct(id) : onSaveProduct();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const filter = createFilterOptions();

  const categoryOptions = categoriesList?.map((v) => {
    return { value: v.id, label: v.name };
  });

  const classesOptions = classes?.map((v) => {
    return { value: v.name, label: v.name };
  }) ?? [];

  const reportCategoryOptions = React.useMemo(() => {
    if (!redcat_plu_class) return [];

    const parentCategory = classes?.find(
      (cat) => cat.name === redcat_plu_class
    );

    return parentCategory?.categories?.map(({ name }) => ({
      value: name,
      label: name,
    })) ?? [];
  }, [redcat_plu_class]);


  if (state.httpStatusCodes.details === 404) {
    return <PageNotFound />;
  }

  return (
    <>
      {validator.current.purgeFields()}
      {id && isLoading ? (
        <Loader />
      ) : (
        <ContentLayout
          title={id ? state.basicDetails.details?.name : "New Product"}
          rightContent={
            <>
              <Button
                type="button"
                size="medium"
                variant="contained"
                disabled={isSaveButton}
                onClick={onSubmit}
              >
                {id ? "Update" : "Save"}
              </Button>
            </>
          }
          breadcrumbs={
            <HeaderBreadcrumbs
              heading=""
              links={[
                { name: "Dashboard", href: "/" },
                { name: "Products", href: "/products" },
                id
                  ? {
                    name: state.basicDetails.details?.name,
                    href: `/products/details/${id}`,
                  }
                  : null,
                { name: id ? "Edit" : "Create" },
              ].filter(Boolean)}
            />
          }
        >
          <Card sx={{ py: "32px", mb: "24px" }}>
            <Grid container spacing={2} px={"24px"}>
              <Grid item xs={12} sm={4}>
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  sx={{ width: "150px" }}
                >
                  Basic Details
                </Typography>
              </Grid>
              <Grid item sm={8}>
                <Stack width={"100%"} gap="20px">
                  <Box>
                    <Stack direction="row" gap="20px">
                      <Avatar
                        sx={{ height: "80px", width: "80px" }}
                        variant="rounded"
                      >
                        <img
                          width="80px"
                          height="80px"
                          src={image ? image : Avadar_img}
                        />
                      </Avatar>
                      <div>
                        <input
                          id="contained-button-file"
                          name="image"
                          type="file"
                          onChange={(e) => handleProductInputChange(e)}
                          style={{ display: "none" }}
                        />
                        <label htmlFor="contained-button-file">
                          <Button
                            color="info"
                            component="span"
                            sx={{ mt: 2 }}
                            onClick={(e) => handleProductInputChange(e)}
                          >
                            {id ? "Change" : "Upload"}
                          </Button>
                        </label>
                      </div>
                    </Stack>
                    <Stack>
                      <Typography variant="body2" color="#808080" mt={1}>
                        Upload an image with 1:1 ratio and less than 1MB.
                      </Typography>
                      <FormHelperText sx={{ color: "#C60808" }}>
                        {validator.current.message(
                          "Image",
                          imageData,
                          "IconSize|IconFormat"
                        )}
                      </FormHelperText>
                    </Stack>
                  </Box>
                  <InputControl
                    name="name"
                    label="Name*"
                    value={name}
                    onChange={handleProductInputChange}
                    error={validator.current.message(
                      "Name",
                      name,
                      "required|min:2"
                    )}
                    helperText={validator.current.message(
                      "Name",
                      name,
                      "required|min:2"
                    )}
                  />
                  <Stack direction="row" gap="20px">
                    <InputControl
                      name="alias"
                      label="Alias"
                      value={alias}
                      onChange={handleProductInputChange}
                      error={validator.current.message(
                        "Alias",
                        alias,
                        "required"
                      )}
                      helperText={validator.current.message(
                        "Alias",
                        alias,
                        "required"
                      )}
                      required
                    />
                    <InputControl
                      type="dropdown"
                      name="colour"
                      label="Colour Code (#)"
                      options={colorOptions}
                      value={colour}
                      includeInputInList
                      filterSelectedOptions
                      required
                      onChange={(e, newValue) => {
                        handleColor(newValue);
                      }}
                      sx={{
                        "& input": { px: "4px !important" },
                      }}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          <Box
                            sx={{
                              bgcolor: option.label,
                              width: "20px",
                              height: "20px",
                              borderRadius: "3px",
                              mr: "4px",
                            }}
                          ></Box>

                          {option.label}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            borderRadius: "8px",
                            ".MuiInputBase-root": { height: "44px" },
                          }}
                          label="Colour"
                          required
                          error={validator.current.message(
                            "Color Code",
                            colour,
                            "required"
                          )}
                          helperText={validator.current.message(
                            "Color Code",
                            colour,
                            "required"
                          )}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: !colour ? (
                              ""
                            ) : (
                              <InputAdornment position="start">
                                <Box
                                  sx={{
                                    bgcolor: !colour ? "#F2F2F2" : colour,
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "3px",
                                  }}
                                ></Box>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </Stack>
                  <InputControl
                    name="short_description"
                    label="Short Description*"
                    value={short_description}
                    onChange={handleProductInputChange}
                    error={validator.current.message(
                      "Description",
                      short_description,
                      "required|min:2"
                    )}
                    helperText={validator.current.message(
                      "Description",
                      short_description,
                      "required|min:2"
                    )}
                  />
                  <Stack direction="row" gap="20px">
                    <InputControl
                      type="select"
                      name="category_id"
                      value={category_id}
                      label="Category*"
                      optionValue={categoryOptions}
                      onChange={handleProductInputChange}
                      error={validator.current.message(
                        "Category",
                        category_id,
                        "required"
                      )}
                      helperText={validator.current.message(
                        "Category",
                        category_id,
                        "required"
                      )}
                      required
                    />

                    <InputControl
                      type="select"
                      name="product_type"
                      label="Product Type*"
                      value={product_type}
                      disabled={updateMode}
                      onChange={handleProductInputChange}
                      optionValue={globalData?.product?.type ?? []}
                      error={validator.current.message(
                        "Product Type",
                        product_type,
                        "required"
                      )}
                      helperText={validator.current.message(
                        "Product Type",
                        product_type,
                        "required"
                      )}
                    />
                  </Stack>

                  <InputControl
                    value={modifier}
                    type="dropdown"
                    name="modifier"
                    label="Allergens & Dietary"
                    className="tags-input"
                    options={globalData?.product?.modifiers ?? []}
                    multiple
                    onChange={(event, newValue) => {
                      handleProductInputChange({
                        target: {
                          name: "modifier",
                          value: newValue,
                        },
                      });
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);
                      return filtered;
                    }}
                    selectOnFocus
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    getOptionLabel={(option) => {
                      return option.value;
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>{option.label}</li>
                    )}
                    renderInput={(params) => (
                      <TextField {...params} label="Allergens & Dietary" />
                    )}
                  />
                  <InputControl
                    name="kilojoules"
                    type="number"
                    label="Energy-Average Qty per Serve (kJ)"
                    value={kilojoules}
                    onChange={handleProductInputChange}
                    isDisabledKeys={["-", '.']}
                  />
                  <InputControl
                    type="select"
                    name="tax_group_id"
                    label="Tax Group*"
                    optionValue={taxGroupList}
                    value={tax_group_id}
                    onChange={handleProductInputChange}
                    error={validator.current.message(
                      "Tax Group",
                      tax_group_id,
                      "required"
                    )}
                    helperText={validator.current.message(
                      "Tax Group",
                      tax_group_id,
                      "required"
                    )}
                  />
                  {product_type !== "modifier" && (
                    <InputControl
                      value={tags}
                      type="dropdown"
                      name="tags"
                      label="Bump Screen Tags"
                      multiple
                      className="tags-input"
                      onChange={(event, newValue) => {
                        if (typeof newValue === "string") {
                          handleProductInputChange({
                            target: {
                              name: "tags",
                              value: newValue,
                            },
                          });
                        } else if (newValue && newValue.inputValue) {
                          // Create a new value from the user input
                          handleProductInputChange({
                            target: {
                              name: "tags",
                              value: newValue.inputValue,
                            },
                          });
                        } else {
                          handleProductInputChange({
                            target: {
                              name: "tags",
                              value: newValue,
                            },
                          });
                        }
                      }}
                      filterOptions={(options, params) => {
                        const filtered = filter(options, params);

                        const { inputValue } = params;
                        // Suggest the creation of a new value
                        const isExisting = options.some(
                          (option) => inputValue === option
                        );
                        if (inputValue !== "" && !isExisting) {
                          filtered.push(inputValue);
                        }

                        return filtered;
                      }}
                      selectOnFocus
                      clearOnBlur
                      handleHomeEndKeys
                      id="free-solo-with-text-demo"
                      options={state?.productTags}
                      getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === "string") {
                          return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                          return option.inputValue;
                        }
                        // Regular option
                        return option;
                      }}
                      renderOption={(props, option) => (
                        <li {...props}>{option}</li>
                      )}
                      freeSolo
                      renderInput={(params) => (
                        <TextField {...params} label="Product tags" />
                      )}
                    />
                  )}
                  <InputControl
                    value={marketing_tags}
                    type="dropdown"
                    name="marketing_tags"
                    label="B Tags"
                    multiple
                    className="tags-input"
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        handleProductInputChange({
                          target: {
                            name: "marketing_tags",
                            value: newValue,
                          },
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        handleProductInputChange({
                          target: {
                            name: "marketing_tags",
                            value: newValue.inputValue,
                          },
                        });
                      } else {
                        handleProductInputChange({
                          target: {
                            name: "marketing_tags",
                            value: newValue,
                          },
                        });
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some(
                        (option) => inputValue === option
                      );
                      if (inputValue !== "" && !isExisting) {
                        filtered.push(inputValue);
                      }

                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={state?.marketingTags}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option;
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>{option}</li>
                    )}
                    freeSolo
                    renderInput={(params) => (
                      <TextField {...params} label="Marketing Tags" />
                    )}
                  />

                  <Stack direction="row" spacing={3}>
                    <InputControl
                      type="outlinedInput"
                      inputType="text"
                      inputLabel="PLU Code"
                      label="PLU Code"
                      placeholder="PLU Code"
                      name="plu"
                      value={plu}
                      onChange={handleProductInputChange}
                      endAdornment={
                        <InputAdornment position="start">
                          <Tooltip title="If left empty, will be auto-generated.">
                            <img alt="details" src="/icons/ic_info.svg" />
                          </Tooltip>
                        </InputAdornment>
                      }
                    />
                    <InputControl
                      name="old_plu"
                      label="Old PLU Code"
                      value={old_plu}
                      onChange={handleProductInputChange}
                    />
                  </Stack>
                  {!["bundle", "modifier"].includes(product_type) && (
                    <InputControl
                      value={bump_screen_tags}
                      type="dropdown"
                      name="bump_screen_tags"
                      label="Bump Screen Tags"
                      className="tags-input"
                      multiple
                      onChange={(event, newValue) => {
                        if (typeof newValue === "string") {
                          handleProductInputChange({
                            target: {
                              name: "bump_screen_tags",
                              value: newValue,
                            },
                          });
                        } else if (newValue && newValue.inputValue) {
                          // Create a new value from the user input
                          handleProductInputChange({
                            target: {
                              name: "bump_screen_tags",
                              value: newValue.inputValue,
                            },
                          });
                        } else {
                          handleProductInputChange({
                            target: {
                              name: "bump_screen_tags",
                              value: newValue,
                            },
                          });
                        }
                      }}
                      filterOptions={(options, params) => {
                        const filtered = filter(options, params);

                        const { inputValue } = params;
                        // Suggest the creation of a new value
                        const isExisting = options.some(
                          (option) => inputValue === option
                        );
                        if (inputValue !== "" && !isExisting) {
                          filtered.push(inputValue);
                        }

                        return filtered;
                      }}
                      selectOnFocus
                      clearOnBlur
                      handleHomeEndKeys
                      id="free-solo-with-text-demo"
                      options={state?.BumpScreenTags}
                      getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === "string") {
                          return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                          return option.inputValue;
                        }
                        // Regular option
                        return option;
                      }}
                      renderOption={(props, option) => (
                        <li {...props}>{option}</li>
                      )}
                      freeSolo
                      renderInput={(params) => (
                        <TextField {...params} label="Bump Screen Tags" />
                      )}
                    />
                  )}

                  <Stack
                    sx={{
                      flexDirection: "row",
                      gap: "10px"
                    }}
                  >
                    <InputControl
                      type="dropdown"
                      options={classesOptions}
                      value={
                        classesOptions?.find(
                          (classItem) => classItem.value === redcat_plu_class
                        ) ?? null
                      }
                      disableClearable={true}
                      onChange={(e, newValue) => {
                        handleProductInputChange({
                          target: {
                            name: "redcat_plu_class",
                            value: newValue?.value ?? newValue,
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Class Name" required
                          error={validator.current.message(
                            "Report Class Name",
                            redcat_plu_class,
                            "required"
                          )}
                          helperText={validator.current.message(
                            "Report Class Name",
                            redcat_plu_class,
                            "required"
                          )}
                        />
                      )}
                    />

                    <InputControl
                      type="dropdown"
                      options={reportCategoryOptions}
                      value={
                        reportCategoryOptions?.find(
                          (classItem) => classItem.value === redcat_category
                        ) ?? null
                      }
                      disableClearable={true}
                      onChange={(e, newValue) => {
                        handleProductInputChange({
                          target: {
                            name: "redcat_category",
                            value: newValue?.value ?? newValue,
                          },
                        });
                      }}
                      disabled={!redcat_plu_class}
                      renderInput={(params) => (
                        <TextField {...params} label="Report Category"
                          required
                          
                          error={validator.current.message(
                            "Report Category",
                            redcat_category,
                            "required"
                          )}
                          helperText={validator.current.message(
                            "Report Category",
                            redcat_category,
                            "required"
                          )} />
                      )}
                    />

                  </Stack>
                </Stack>
              </Grid>
            </Grid>
            {["retail", "platter"].includes(product_type) && (
              <Grid
                container
                mt={5}
                spacing={2}
                sx={{ px: "24px", py: 1, borderTop: "1px solid #E6E6E6" }}
              >
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle1" fontWeight={600}>
                    Product Sticker Printing
                  </Typography>
                </Grid>
                <Grid item sm={8} gap="8px">
                  <Switch
                    checked={sticker_printing ? true : false}
                    name="sticker_printing"
                    onChange={handleProductInputChange}
                  />
                  <Stack direction="row" gap={1} alignItems="center">
                    <Box
                      component="img"
                      src={infoIcon}
                      width="16px"
                      height="16px"
                    />
                    <Typography
                      sx={{
                        color: "#636363",
                        fontSize: "14px",
                        lineHeight: "16.94px",
                        fontWeight: "400",
                      }}
                    >
                      Enabling this will make the product eligible for sticker
                      printing
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            )}

            <Grid
              container
              mt={5}
              spacing={2}
              sx={{ px: "24px", py: 1, borderTop: "1px solid #E6E6E6" }}
            >
              <Grid item xs={12} sm={4}>
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  sx={{ width: "150px" }}
                >
                  Loyalty Cards
                </Typography>
              </Grid>
              <Grid item sm={8}>
                <FormGroup row>
                  {globalData?.loyalty_cards?.loyalty_card_types.map(
                    (details) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isLoyaltyOptionInclude(details)}
                            onChange={(e) =>
                              handleLoyaltyCheckboxChanges(e, details)
                            }
                          />
                        }
                        label={details.label}
                      />
                    ),
                  )}
                </FormGroup>
                <Stack direction="row" gap={1}>
                  <Box component="img" src={infoIcon} />
                  <Typography
                    sx={{
                      color: "#636363",
                      fontSize: "14px",
                      lineHeight: "16.94px",
                      fontWeight: "400",
                    }}
                  >
                    If selected, purchasing this product will earn loyalty
                    points for the associated card type.
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Card>

          {product_type !== "bundle" && (
            <>
              {!isEditMode && isCreate && (
                <Card sx={{ p: "32px 24px", mb: "24px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        sx={{ width: "150px" }}
                      >
                        Accounts
                      </Typography>
                    </Grid>
                    <Grid item sm={8}>
                      <InputControl
                        value={accountsList.selectedAccountIds}
                        type="dropdown"
                        name="account_id"
                        label="Account Name"
                        className="tags-input"
                        options={state.accountsList.listData}
                        multiple
                        onChange={(_, newValue) => {
                          handleProductInputChange({
                            target: {
                              name: "account_id",
                              value: newValue,
                            },
                          });
                        }}
                        filterOptions={(options, params) => {
                          const filtered = filter(options, params);
                          return filtered;
                        }}
                        selectOnFocus
                        handleHomeEndKeys
                        id="account_name"
                        getOptionLabel={(option) => {
                          return option.name;
                        }}
                        renderOption={(props, option) => (
                          <li {...props}>{option.name}</li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Account Name"
                            required
                            error={validator.current.message(
                              "account_name",
                              state.accountsList.selectedAccountIds,
                              "required"
                            )}
                            helperText={validator.current.message(
                              "account_name",
                              state.accountsList.selectedAccountIds,
                              "required"
                            )}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Card>
              )}
            </>
          )}

          {product_type !== "modifier" && (
            <>
              {!id && (
                <Card sx={{ p: "32px 24px", mb: "24px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        sx={{ width: "150px" }}
                      >
                        Product Variants
                      </Typography>
                    </Grid>
                    <Grid item sm={8}>
                      <Stack width={"100%"} gap="20px" alignItems="flex-end">
                        <Switch
                          checked={has_variant ? true : false}
                          name="has_variant"
                          onChange={handleProductInputChange}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                  {has_variant ? (
                    <>
                      <Divider
                        sx={{
                          width: "calc(100% + 48px)",
                          mr: " -24px",
                          ml: " -24px",
                        }}
                      />
                      {variants?.map((data, index) => (
                        <>
                          <Stack
                            direction="row"
                            alignItems="center"
                            gap="12px"
                            py="20px"
                            width="100%"
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              minWidth="105px"
                            >
                              <Radio
                                size="small"
                                checked={data.default === 1}
                                onChange={(e) => {
                                  handleVarientNestedInput("Default", e, index);
                                }}
                                // value={row.id}
                                name="radio-buttons"
                                sx={{
                                  p: "3.5px",
                                }}
                              />
                              <Typography variant="caption" color="#666666">
                                {data.default ? "Default" : "Set as default"}
                              </Typography>
                            </Stack>

                            <InputControl
                              type="outlinedInput"
                              inputType="text"
                              placeholder="Variant Name*"
                              name="name"
                              value={data.name}
                              onChange={(e) => {
                                handleVarientNestedInput("onChange", e, index);
                              }}
                              error={validator.current.message(
                                `Variant Name ${" ".repeat(index)}`,
                                data.name,
                                "required"
                              )}
                              helperText={validator.current.message(
                                `Variant Name ${" ".repeat(index)}`,
                                data.name,
                                "required"
                              )}
                            />

                            <InputControl
                              type="outlinedInput"
                              inputType="text"
                              inputLabel="PLU Code"
                              placeholder="PLU Code"
                              label="PLU Code"
                              name="plu"
                              value={data.plu}
                              onChange={(e) => {
                                handleVarientNestedInput("onChange", e, index);
                              }}
                              size="small"
                              endAdornment={
                                <InputAdornment position="start">
                                  <Tooltip title="If left empty, will be auto-generated.">
                                    <img
                                      alt="details"
                                      src="/icons/ic_info.svg"
                                    />
                                  </Tooltip>
                                </InputAdornment>
                              }
                            />

                            <InputControl
                              type="outlinedInput"
                              inputType="text"
                              placeholder="Old PLU Code"
                              name="old_plu"
                              value={data.old_plu}
                              onChange={(e) => {
                                handleVarientNestedInput("onChange", e, index);
                              }}
                            />

                            <Button
                              variant="contained"
                              sx={{
                                minWidth: "36px",
                                maxWidth: "36px",
                                bgcolor: "rgba(0, 0, 0, 0.0)",
                                "&:hover": {
                                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                                },
                              }}
                              onClick={() => {
                                handleVarientNestedInput("delete", null, index);
                              }}
                              disabled={variants.length === 1 && index === 0}
                            >
                              <img alt="delete" src="/icons/ic_delete.svg" />
                            </Button>
                          </Stack>
                          <Divider sx={{ width: "100%" }} />
                        </>
                      ))}
                      <Button
                        variant="contained"
                        sx={{
                          mt: "20px",
                        }}
                        onClick={() => handleVarientNestedInput("add")}
                      >
                        Add Variant
                      </Button>
                    </>
                  ) : (
                    ""
                  )}
                </Card>
              )}
            </>
          )}
        </ContentLayout>
      )}
    </>
  );
};
